import styled from 'styled-components'
import { Switch, FormGroup, FormControlLabel, SxProps } from '@mui/material'
import { Controller } from 'react-hook-form'

interface Props {
  control?: any
  name: string
  label?: string
  value: boolean
  className?: string
  disabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  switchStyles?: SxProps
  labelPlacement?: 'start' | 'end'
}

export default function SwitchToggle({
  control = null,
  name,
  label = '',
  value,
  className,
  disabled = false,
  onChange,
  switchStyles = {},
  labelPlacement = 'end',
}: Props): JSX.Element {
  if (!control) {
    return (
      <SwitchContainer className={className} $labelPlacement={labelPlacement}>
        <FormControlLabel
          control={<Switch disabled={disabled} checked={value} name={name} onChange={onChange} sx={switchStyles} />}
          label={label}
          labelPlacement={labelPlacement}
        />
      </SwitchContainer>
    )
  }

  return (
    <SwitchContainer className={className} $labelPlacement={labelPlacement}>
      <FormControlLabel
        control={
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <Switch
                disabled={disabled}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                name={field.name}
                sx={switchStyles}
              />
            )}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
      />
    </SwitchContainer>
  )
}

const SwitchContainer = styled(FormGroup)<{ $labelPlacement?: 'start' | 'end' }>`
  display: inline-flex;

  & .MuiFormControlLabel-root {
    margin-left: 0;
  }

  & .MuiSwitch-root {
    left: ${(props) => (props.$labelPlacement === 'start' ? 'auto' : '-12px')};
    right: ${(props) => (props.$labelPlacement === 'end' ? 'auto' : '-12px')};
  }

  & .Mui-checked + .MuiSwitch-track {
    background-color: ${(props) => props.theme.palette.primary.main};
  }
  & .Mui-checked {
    color: ${(props) => props.theme.palette.primary.main};
  }
`
